import iconMixin from '../../mixins/iconMixin'

export default {
  mixins: [iconMixin],
  data: function () {
    return {
      viewBox: "0 0 24 24",
      rawSvgPath: '<rect x="3.5" y="5.5" width="1" height="2"/>' +
                  '<rect x="3.5" y="9.5" width="1" height="2"/>' +
                  '<rect x="3.5" y="13.5" width="1" height="2"/>' +
                  '<rect x="3.5" y="17.5" width="1" height="2"/>' +
                  '<path d="M18.5,2.5h-12c-1.109,0-2,0.9-2,2v1H6v2H4.5v2H6v2H4.5v2H6v2H4.5v2H6v2H4.5v1c0,1.104,0.896,2,2,2h12c1.104,0,2-0.896,2-2' +
                    'v-16C20.5,3.4,19.609,2.5,18.5,2.5z M12.99,5.454c0.759-0.762,1.748-0.751,1.748-0.751s0.008,0.987-0.753,1.749' +
                    'c-0.76,0.761-1.747,0.751-1.747,0.751S12.231,6.215,12.99,5.454z M16,19.5H9v-1h7V19.5z M16,17.5H9v-1h7V17.5z M15.942,12.6' +
                    'c-1.049,1.692-1.699,1.902-2.141,1.9c-0.584-0.003-0.878-0.041-1.302-0.436c-0.424,0.395-0.721,0.433-1.304,0.436' +
                    'c-0.439,0.002-1.091-0.208-2.139-1.9c-0.997-1.608-1.473-4.78,1.013-5.248c1.029-0.193,2.43,0.491,2.43,0.491' +
                    'c0,0,1.401-0.684,2.432-0.491C17.416,7.819,16.938,10.991,15.942,12.6z"/>',
    }
  },
}